import { render, staticRenderFns } from "./form-datetime.vue?vue&type=template&id=72f2c686&scoped=true&"
import script from "./form-datetime.vue?vue&type=script&lang=js&"
export * from "./form-datetime.vue?vue&type=script&lang=js&"
import style0 from "./form-datetime.vue?vue&type=style&index=0&id=72f2c686&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f2c686",
  null
  
)

export default component.exports